import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UtilsModule } from '../utils/utils.module';
import { FooterComponent } from './footer/footer.component';
import { NavComponent } from './nav/nav.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { AddActivitiesComponent } from './add-activities/add-activities.component';
import { AddConversationComponent } from './add-conversation/add-conversation.component';
import { ExperienceComponent } from './experience/experience.component';
import { ActivityDaysComponent } from './activity-days/activity-days.component';
import { EditPostComponent } from './edit-post/edit-post.component';
import { AddCommentComponent } from './add-comment/add-comment.component';
import { LocationComponent } from './location/location.component';
import { IDCardComponent } from './idcard/idcard.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapComponent } from './map/map.component';
import { MatAnimatedIconComponent } from './mat-animated-icon/mat-animated-icon.component';
import { ShareModule } from 'ngx-sharebuttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent } from './header/header.component';
import { CreateInviteComponent } from './create-invite/create-invite.component';
import { PlansComponent } from '../settings/plans/plans.component';
import { LocationPlaceComponent } from './location-place/location-place.component';
import { PendingReviewsComponent } from './pending-reviews/pending-reviews.component';
import { InvitesThisWeekComponent } from './invites-this-week/invites-this-week.component';
import { AcceptedInvitesComponent } from './accepted-invites/accepted-invites.component';

@NgModule({ declarations: [
        HeaderComponent,
        NavComponent,
        ServerErrorComponent,
        FooterComponent,
        SidenavComponent,
        ColorPickerComponent,
        CreateInviteComponent,
        AddActivitiesComponent,
        AddConversationComponent,
        AddCommentComponent,
        ExperienceComponent,
        ActivityDaysComponent,
        EditPostComponent,
        LocationComponent,
        LocationPlaceComponent,
        MapComponent,
        IDCardComponent,
        MatAnimatedIconComponent,
        PlansComponent,
        PendingReviewsComponent,
        InvitesThisWeekComponent,
        AcceptedInvitesComponent
    ],
    exports: [
        GoogleMapsModule,
        HeaderComponent,
        NavComponent,
        SidenavComponent,
        ColorPickerComponent,
        CreateInviteComponent,
        AddActivitiesComponent,
        AddConversationComponent,
        AddCommentComponent,
        ExperienceComponent,
        ActivityDaysComponent,
        EditPostComponent,
        LocationComponent,
        LocationPlaceComponent,
        MapComponent,
        IDCardComponent,
        MatAnimatedIconComponent,
        FooterComponent,
        ServerErrorComponent,
        FontAwesomeModule,
        ShareModule,
        ShareIconsModule,
        PlansComponent,
        PendingReviewsComponent,
        InvitesThisWeekComponent,
        AcceptedInvitesComponent
    ], imports: [CommonModule,
        RouterModule,
        UtilsModule,
        GoogleMapsModule,
        FontAwesomeModule,
        ShareModule,
        ShareIconsModule] })
export class ComponentsModule { }
